module.exports = __webpack_public_path__ + "img/mix.6b84bc74.svg";